import React from "react";
import JobBoard from "./JobBoard";

const JobBoardScreen = () => <JobBoard />;

export default JobBoardScreen;
